import firebase from "firebase";
import {config} from "../../constants";
import {usersRef} from "../../config/firebaseConfig";
import {encodeToFirebase, updateOnlineStatus} from "./helpers";

export function addUserIfNotExists(user, users, userAdded, setUserAdded){
    return () => {
        if (users && user && !userAdded) {
            const existing = users.find(u => u.CustID === user.CustID)
            if (!existing) {
                usersRef.add(user)
                setUserAdded(true)
            }
        }
    }
}

export function onlineUserFetching(setOnlineUsersIds){
    return () => {
        let t = null;
        t = setInterval(() => {
            firebase.database().ref('userping').once('value').then(snapshot => {
                const allStatuses = snapshot.val()

                const onlineIds = Object.entries(allStatuses || [])
                    .filter(([userId, time]) => Date.now() - time < config.ONLINE_TIMEOUT)
                    .map(([userId, time]) => userId)

                setOnlineUsersIds(onlineIds)
            });
        }, config.ONLINE_UPDATE_INTERVAL);
        return () => {
            clearInterval(t)
        };
    }
}

export function updateOnlineStatusPeriodically(user, hideStatus){
    return () => {
        if(user) {
            if (!hideStatus)
                updateOnlineStatus(user, Date.now())
            else updateOnlineStatus(user, Date.now() - config.ONLINE_TIMEOUT - 1000)
        }

        let t = null
        t = setInterval(() => {
            if (user && user.CustID && !hideStatus)
                updateOnlineStatus(user, Date.now())
        }, config.KEEP_ALIVE_INTERVAL)

        return () => {
            clearInterval(t)
        }
    }
}

export function fetchAndListenHideStatus(user, setHideStatus){
    return () => {
        if(!user)
            return
        firebase.database().ref('/userHideStatus/'+user.CustID).once('value').then(snapshot => {
            setHideStatus(snapshot.val())
        })
        firebase.database().ref('/userHideStatus/'+user.CustID).on('value', snapshot => {
            setHideStatus(snapshot.val())
        })
    }
}